import { afterNavigate } from '$app/navigation';

export function createKitAfterNavigateCallbacks() {
	const onAfterNavigateCallbacks: (() => void)[] = [];

	afterNavigate(() => {
		for (const callback of onAfterNavigateCallbacks) {
			callback?.();
		}
		onAfterNavigateCallbacks.splice(0);
	});

	return {
		add(callback: () => void) {
			onAfterNavigateCallbacks.push(callback);
		},
	};
}
